export default class mainNav {

    constructor() {
        this.init();
        this._nav_border();
        this._insert_button();
    }

    init() {
        $('.ae-navbar-nav > li').each(function () {
            $(this).addClass('focus-control');
        });

        $('.ae-navbar-nav > li > span').focusin(function () {
            var sel = this;
            setTimeout(function () {
                $('li').removeClass('focus-active');
            }, 50);
        });

        $('.ae-navbar-nav > li').hover(function () {
            var eleHover = $(this);
            $('.ae-navbar-nav > li.focus-active').each(function () {
                $(this).removeClass('');
                if (this !== eleHover.get(0)) {
                    $(this).removeClass('focus-active');
                }

            });
        });

        $('.ae-navbar-nav > li > span').keydown(function (e) {
            var p = e.which;
            if (p === 13 && $(this).parent('li').find('.ae-dropdown-menu').length) {
                e.preventDefault();
                if ($(this).parents('li').hasClass('focus-active')) {
                    $(this).parents('li').removeClass('focus-active');
                } else {
                    $(this).parents('li').addClass('focus-active');
                }
            }
        });

        $('.ae-navbar-nav > li > span').click(function (e) {
            if ($(this).parent('li').find('.ae-dropdown-menu').length) {
                e.preventDefault();
                if ($(this).parents('li').hasClass('focus-active')) {
                    $(this).parents('li').removeClass('focus-active');
                } else {
                    $('li').removeClass('focus-active');
                    $(this).parents('li').addClass('focus-active');
                }
            }
        });
    }

    _nav_border(){
        var $parent = $('.ae-navbar-nav');
        var barColor = "<li class='nav-border'></li>";

        $parent.children('li:not(".nav-border")').each(function(){
            var $selector = $(this);
            $(barColor).insertAfter($selector);
        });
    }

    _insert_button(){
        var $sibling = $('.menu-multi-column').parent().find('span');
        $sibling.css('display', 'inline-block');
        var button = "<a href='/focus-areas/courses' aria-label='Browse All Categories' class='blue-small icon-course hvr-bounce-to-right hvr-icon-bounce browse-all-button'>All Categories&nbsp;&nbsp;<i class='fa fa-cubes hvr-icon'></i></a>";
        $(button).insertAfter($sibling);
    }
}
